import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';

const stats = [
  { value: '5+', label: "Années d'expérience" },
  { value: '20+', label: 'Projets cinéma' },
  { value: '400k+', label: 'Euros levés' },
  { value: '15+', label: 'Partenaires' },
];

export const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section 
      id="about-section" 
      className="py-24 md:py-32 bg-[#0a0a0c]"
      data-testid="about-section"
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <span className="overline mb-4 block">À propos de nous</span>
            <h2 className="text-3xl md:text-5xl font-medium mb-6 leading-tight">
              Second Souffle Production
            </h2>
            <div className="gold-line mb-8" />
            <p className="text-[#a1a1aa] text-lg leading-relaxed mb-8">
              Second Souffle Production est un <strong className="text-white">fonds de dotation dédié au cinéma indépendant</strong>. 
              Nous soutenons des œuvres engagées, ambitieuses et accessibles, qui mettent en lumière 
              des réalités humaines, sociales et culturelles. Par la <strong className="text-white">distribution non commerciale</strong>, 
              nous contribuons à faire émerger les cinéastes de demain et à renforcer l'impact du cinéma 
              auprès du plus grand nombre.
            </p>
            <Link
              to="/faire-un-don"
              className="btn-primary inline-block"
              data-testid="about-donate-btn"
            >
              Soutenir notre mission
            </Link>
          </motion.div>

          {/* Right Stats */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-5"
          >
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                  className="glass p-6 rounded-2xl text-center"
                  data-testid={`stat-${index}`}
                >
                  <div className="stat-number mb-2">{stat.value}</div>
                  <div className="text-[#a1a1aa] text-sm">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
